import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  buildAgencyFundGeniusBasePath,
  buildAgencyFundGeniusPath,
  buildPlatformFundGeniusBasePath,
  buildPlatformFundGeniusPath,
  buildStandaloneFundGeniusPath,
} from '../../utils/funding/routes';

export function useFundingRoutes() {
  const { agencyId: routeAgencyId } = useParams();
  const location = useLocation();

  return useMemo(() => {
    const isPlatformContext = location.pathname.startsWith('/platform/fundgenius-hq');
    const isAgencyContext = Boolean(routeAgencyId) && !isPlatformContext;

    const basePath = isPlatformContext
      ? buildPlatformFundGeniusBasePath()
      : isAgencyContext
        ? buildAgencyFundGeniusBasePath(routeAgencyId)
        : buildStandaloneFundGeniusPath();

    const pathFor = (segment = '') => {
      if (isPlatformContext) {
        return buildPlatformFundGeniusPath(segment);
      }
      if (isAgencyContext) {
        return buildAgencyFundGeniusPath(routeAgencyId, segment);
      }
      return buildStandaloneFundGeniusPath(segment);
    };

    return {
      agencyId: isAgencyContext ? routeAgencyId : null,
      isPlatformContext,
      isAgencyContext,
      basePath,
      pathFor,
      dashboard: pathFor(),
      clients: pathFor('clients'),
      profiles: pathFor('profiles'),
      readiness: pathFor('readiness'),
      advisor: pathFor('ai-advisor'),
      documents: pathFor('documents'),
      match: pathFor('match'),
      lenders: pathFor('lenders'),
      sequence: pathFor('sequence'),
      submissions: pathFor('submissions'),
      pipeline: pathFor('pipeline'),
      commissions: pathFor('commissions'),
      reports: pathFor('reports'),
      settings: pathFor('settings'),
    };
  }, [location.pathname, routeAgencyId]);
}
